import styled from 'styled-components'

const Mask = styled.div`
  position: fixed;
  width: 100vw;
  height: 100vh;
  z-index: 999;
  background: rgba(0, 0, 0, 0.58);
`

export default function PageMask ({ enable, children }) {
  return <>
    {enable ? <Mask/> : <></>}
    {children}
  </>
}